import { Chip } from "@mui/material";
import { useState } from "react";

import type { ChipProps, SxProps, Theme } from "@mui/material";
import type { FC } from "react";

export const HoverChip: FC<
  ChipProps & { hoverProps?: ChipProps } & { defaultProps?: ChipProps }
> = ({ defaultProps, hoverProps, ...props }) => {
  const [hover, setHover] = useState(false);

  const usedProps = hover ? hoverProps : defaultProps;

  return (
    <Chip
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      {...props}
      {...usedProps}
      sx={
        // oxlint-disable-next-line typescript/no-unsafe-type-assertion
        {
          ...props.sx,
          ...usedProps?.sx,
          cursor: "pointer",
        } as SxProps<Theme>
      }
    />
  );
};
